import type { DeleteCallOffItemVariables } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodDeleteCallOffItemEndpointSchema } from './validations';

/**
 * Soft deletes a line item from a call-off.
 *
 * @param variables - The call-off ID and item ID to delete.
 * @param options - Optional request options (e.g., abort signal).
 * @returns A promise that resolves when the item is deleted.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Call-Offs/operation/delete_calloff_item_calloffs__calloff_id__items__item_id__delete
 */
export const deleteCallOffItem = async (
  variables: DeleteCallOffItemVariables,
  options?: KyRequestOptions,
) => {
  const { callOffId, itemId } = variables;

  await vestigasApi.delete(ENDPOINT.CALL_OFF.DELETE_ITEM(callOffId, itemId), {
    validate: {
      pathSegments: zodDeleteCallOffItemEndpointSchema,
    },
    ...options,
  });
};
